// extracted by css-extract-rspack-plugin
export default {"sidebarAppButton":"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-AppsSidebar-SidebarAppButton-SidebarAppButton-module__sidebarAppButton-vzACpB","icon":"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-AppsSidebar-SidebarAppButton-SidebarAppButton-module__icon-uzSVv_","label":"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-AppsSidebar-SidebarAppButton-SidebarAppButton-module__label-VQcpF_","active":"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-AppsSidebar-SidebarAppButton-SidebarAppButton-module__active-mPOaGz"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"sidebarAppButton\":\"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-AppsSidebar-SidebarAppButton-SidebarAppButton-module__sidebarAppButton-vzACpB\",\"icon\":\"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-AppsSidebar-SidebarAppButton-SidebarAppButton-module__icon-uzSVv_\",\"label\":\"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-AppsSidebar-SidebarAppButton-SidebarAppButton-module__label-VQcpF_\",\"active\":\"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-AppsSidebar-SidebarAppButton-SidebarAppButton-module__active-mPOaGz\"}";
        // 1793875576339
        var cssReload = require("../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  